import React, { Component } from "react";
import {
  Form,
  Grid,
  Header,
  Message,
  Segment,
  Container,
  Image
} from "semantic-ui-react";

import * as LINKS from "../assets/Links";
import LOGO from "../assets/images/logo.png";
// import Footer from "../components/Footer";

class Login extends Component {
  state = { email: "", password: "", success: false, errorMsg: '', error: false };

  handleChange = (e, { name, value }) => this.setState({ [name]: value });

  handleSubmit = () => {
    // console.log(this.state.email + " " + this.state.password);
    // console.log(LINKS.SERVER_BASE_URL + LINKS.SERVER_ROUTES.login);
    fetch(LINKS.SERVER_BASE_URL + LINKS.SERVER_ROUTES.login, {
      mode: "cors",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        Accept: "application/json"
      },
      body: JSON.stringify({
        email: this.state.email,
        password: this.state.password
      })
    })
      .then(resp => resp.json())
      .then(data => {
        if (!data["jwt_token"]) {
          console.log(data);
          this.setState({errorMsg: data['error'], error: true})
        } else {
          // console.log(data);
          localStorage.setItem("dat", data["jwt_token"]);
          localStorage.setItem("id", data["id"]);
          localStorage.setItem("email", data["email"]);
          this.setState({ success: true, error: false });
          console.log("Logged In!");
        }
      });
  };

  render() {
    const { email, password } = this.state;
    return (
      <Grid centered verticalAlign="middle" style={{backgroundColor: "#111111", height: '110vh'}} >
        <Container fluid text textAlign="center">
          <Image
            src={LOGO}
            size="tiny"
            centered
            style={{ marginTop: "3em", backgroundColor: "#111111" }}
          />
          <Header as="h2" textAlign="center" inverted>
            Member Login
          </Header>
          <Grid centered verticalAlign="middle">
            <Grid.Column>
              <Segment>
                <Form
                  size="large"
                  /* action='#/team' */ onSubmit={this.handleSubmit}
                >
                  <Form.Input
                    fluid
                    name="email"
                    icon="user"
                    iconPosition="left"
                    placeholder="Email address"
                    value={email}
                    onChange={this.handleChange}
                  />
                  <Form.Input
                    fluid
                    name="password"
                    icon="lock"
                    iconPosition="left"
                    placeholder="Password"
                    type="password"
                    value={password}
                    onChange={this.handleChange}
                  />
                  <Message positive success={!this.state.success}>
                    <Message.Header>Welcome</Message.Header>
                    <Message.Content>
                      <a href="/#/VrfHpcV3wHQHFD5">Click Here to go to your dashboard</a>
                    </Message.Content>
                  </Message>
                  <Message negative error={!this.state.error}>
              <Message.Content>
                {this.state.errorMsg + ", Reload and Retry Again..."}
              </Message.Content>
            </Message>
                  <Form.Button
                    color="black"
                    fluid
                    size="large"
                    type="submit"
                    disabled={!this.state.email || !this.state.password || this.state.success}
                  >
                    Login
                  </Form.Button>
                </Form>
              </Segment>
              <Message>
                {/* Not registered yet? <a href="#">Sign Up</a> */}
                This page is meant only for RCS team.
                <br />
                <a href="/">Don't know what to do here? Let's go back home</a>
              </Message>
            </Grid.Column>
          </Grid>
        </Container>
      </Grid>
    );
  }
}

export default Login;
